module.exports = __webpack_public_path__ + "static/media/10-15-1-Dawn.3834bd5c.jpg";